import React, { Component, Fragment } from "react";
import styles from "./ChatScreen.module.scss"
import OutgoingChatBox from "./OutgoingChatBox";
import Header from "./Header";
import { connect } from 'react-redux'
import ChatMessage from "./ChatMessage";
import Message from "../../domain/Message";
import TypingIndicator from "../widgets/TypingIndicator";
import ScrollToBottom from 'react-scroll-to-bottom';

class ChatScreen extends Component {
  enableCheatMode() {
    let dispatch = this.props.storyDispatch;
    document.onkeyup = function (e) {
      if (e.shiftKey && e.key === "H") {
        let passageName = prompt("Enter the passage ID you want to travel to", "");
        if (passageName && passageName !== "") dispatch.advanceToPassage(passageName);
      }
    };
  }

  render() {
    return <Fragment>
      <Header storyName={this.props.storyName}/>

      <ScrollToBottom className={styles.passages}>
        {this.props.receivedMessages.map(it =>
          <ChatMessage
            key={it.id}
            message={it}
            className={
              it.isIncoming() ?
                styles.incomingMessage :
                styles.outgoingMessage
            }/>)
        }
        <TypingIndicator show={this.props.loading && this.props.nextMessage && this.props.nextMessage.getIsTyping()}/>
      </ScrollToBottom>

      <OutgoingChatBox storyName={this.props.storyName}/>
    </Fragment>;
  }
}

const mapState = (state, props) => {
  const storyName = props.storyName;
  const story = state[storyName];
  const nextMessage = story.scheduledMessages[0] && new Message(story.scheduledMessages[0].message);
  return {
    nextMessage,
    receivedMessages: story.receivedMessages.map(it => new Message(it)),
    loading: state.loading.effects[storyName].resumeScheduledMessages
  };
};

const mapDispatch = (state, props) => {
  const storyDispatch = state[props.storyName];
  return { storyDispatch };
};

export default connect(mapState, mapDispatch)(ChatScreen);